import type {
  EstimateCard,
  EstimateDiff,
  EstimateSummary,
  ProjectEstimatesSummary,
  ResourceStatement,
} from '@epc/contracts';
import { queryOptions } from '@tanstack/react-query';
import { api } from '../../lib/api';

export const estimatesQuery = (q: { projectId?: string; objectId?: string; all?: boolean }) =>
  queryOptions({
    queryKey: ['estimates', q],
    queryFn: () =>
      api<EstimateSummary[]>('/estimates', {
        query: { projectId: q.projectId, objectId: q.objectId, all: q.all ? 'true' : undefined },
      }),
    enabled: Boolean(q.projectId),
  });

/** Карточка сметы: шапка и разделы с хранимыми итогами, без позиций (limit=0); позиции — страницами (est-10) */
export const estimateQuery = (id: string) =>
  queryOptions({
    queryKey: ['estimate', id],
    queryFn: () => api<EstimateCard>(`/estimates/${id}`, { query: { limit: 0 } }),
  });

export const estimateResourcesQuery = (id: string) =>
  queryOptions({
    queryKey: ['estimate', id, 'resources'],
    queryFn: () => api<ResourceStatement>(`/estimates/${id}/resources`),
  });

export const projectResourcesQuery = (projectId: string, objectId?: string) =>
  queryOptions({
    queryKey: ['estimates', 'resources', projectId, objectId],
    queryFn: () => api<ResourceStatement>('/estimates/resources', { query: { projectId, objectId } }),
  });

export const estimatesSummaryQuery = (projectId: string) =>
  queryOptions({
    queryKey: ['estimates', 'summary', projectId],
    queryFn: () => api<ProjectEstimatesSummary>('/estimates/summary', { query: { projectId } }),
  });

export const estimateDiffQuery = (a: string, b: string) =>
  queryOptions({
    queryKey: ['estimates', 'diff', a, b],
    queryFn: () => api<EstimateDiff>('/estimates/diff', { query: { a, b } }),
  });

const qtyFmt = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 4 });
const qtyFmt7 = new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 7 });

/** Объём: до 4 знаков, малые нормы — до 7 */
export function qty(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  return Math.abs(v) < 0.001 && v !== 0 ? qtyFmt7.format(v) : qtyFmt.format(v);
}

const money2 = new Intl.NumberFormat('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

/** Сумма с копейками, без «₸» — для таблиц сметы; null — суммы скрыты */
export function sum(v: number | null | undefined): string {
  if (v === null || v === undefined || Number.isNaN(v)) return '—';
  return money2.format(v);
}

/** Чел.-ч и маш.-ч */
export function hours(v: number | null | undefined): string {
  if (v === null || v === undefined) return '—';
  return new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(v);
}
